export const COLOR_PALETTE = '/color_palette' as const
